import { CIcon } from '~/icons/types'
export const ciPlugin: CIcon = {
  name: 'plugin',
  type: 'regular',
  width: 512,
  height: 512,
  paths: [
    {
      d:
        'M448.801 271H497c8.284 0 15-6.716 15-15V111.4c0-8.284-6.716-15-15-15H367.4V63.2c0-34.849-28.352-63.2-63.2-63.2S241 28.352 241 63.2v33.2H111.4c-8.284 0-15 6.716-15 15V241H63.2C28.352 241 0 269.352 0 304.2s28.352 63.2 63.2 63.2h33.2V497c0 8.284 6.716 15 15 15H256c8.284 0 15-6.716 15-15v-48.2c0-18.307 14.894-33.2 33.2-33.2 18.306 0 33.2 14.894 33.2 33.2V497c0 8.284 6.716 15 15 15H497c8.284 0 15-6.716 15-15V352.4c0-8.284-6.716-15-15-15h-48.199c-18.308 0-33.201-14.894-33.201-33.2 0-18.306 14.893-33.2 33.201-33.2zm0 96.4H482V482H367.4v-33.2c0-34.849-28.352-63.2-63.2-63.2S241 413.951 241 448.8V482H126.4V352.4c0-8.284-6.716-15-15-15H63.2c-18.307 0-33.2-14.894-33.2-33.2 0-18.306 14.894-33.2 33.2-33.2h48.2c8.284 0 15-6.716 15-15V126.4H256c8.284 0 15-6.716 15-15V63.2c0-18.307 14.894-33.2 33.2-33.2 18.306 0 33.2 14.894 33.2 33.2v48.2c0 8.284 6.716 15 15 15H482V241h-33.199c-34.85 0-63.201 28.352-63.201 63.2s28.351 63.2 63.201 63.2z',
      fill: 'currentColor'
    }
  ]
}
